<template>
    <div class=" d-flex align-items-center justify-content-between">
        <h5>Products/Services</h5>
        <router-link to="/subscription" class="btn btn-secondary btn-sm btn-warning">
            <i class="bx bx-plus me-2"></i>
            <span class="align-middle">Add Plan</span>
        </router-link>

    </div>
    
    <div class="table-responsive text-nowrap">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Plan Name</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody class="table-border-bottom-0">

                <tr v-if="!subscriptions || subscriptions.length === 0">
                    <td colspan="3" style="text-align: center;">No product and services found.</td>
                </tr>

                <tr v-else v-for="subscription in subscriptions"  :key="subscription.subscription_id">
                    <PlanComponent :data="subscription.subscription_id" />
                </tr>
                
            </tbody>
        </table>
    </div>

</template>

<script>
    import PlanComponent from './product/Plan.vue';
    export default {
        components: { PlanComponent },
        props: {
            subscriptions: {
                type: Array,
                default: () => [],
            },
        },
        methods: {

        }
    
    };
</script>
